export default __webpack_public_path__ + "static/media/328.45af30c5.gif";